export const CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28AFF', '#FF6384']

export const DEFAULT_CHART_WIDTH = 400
export const DEFAULT_CHART_HEIGHT = 300

export const CHART_MARGIN = {
  top: 20,
  right: 30,
  left: 20,
  bottom: 5,
}
